/**
 * Deploy-time flags read from the stage's config.json. There is no runtime flag service here, so
 * an unreadable or absent flag means off — a stage is opted in only by its own deployed config.
 */
export const isNetradyneDissociationEnabled = (config: unknown): boolean => {
    if (typeof config !== 'object' || config === null) {
        return false;
    }

    const flags = (config as { feature_flags?: unknown }).feature_flags;
    if (typeof flags !== 'object' || flags === null) {
        return false;
    }

    return (flags as { netradyne_dissociation_enabled?: unknown }).netradyne_dissociation_enabled === true;
};
